import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
    } from '@/components/ui/alert-dialog';
    import type { Voucher, SharedData } from '@/types';
    import { toast } from 'vue-sonner';
    import { useForm } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import type { Table } from '@tanstack/vue-table';
    import { computed, watch } from 'vue';
    import { usePage } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkRemoveVouchersAlertDialog',
  props: {
    table: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const voucherStore = useVoucherStore();
    const queryClient = useQueryClient();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth?.user.selected_company_id);

    const props = __props;

    const form = useForm({
        ids: [] as number[],
    });

    watch(
        () => voucherStore.validVoucherIds,
        (newIds) => {
            form.ids = newIds;
        },
        { immediate: true },
    );

    const close = () => {
        form.post(route('v2.voucher.admin.remove.selection'), {
            preserveScroll: true,
            onSuccess: () => {
                toast.success(t('vouchers.select.removed.success'));
                props.table.resetRowSelection();
                queryClient.invalidateQueries({
                    queryKey: [QueryKey.VOUCHERS, selectedCompanyId.value],
                });
            },
        });
    };

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_unref(AlertDialog), {
    open: _unref(voucherStore).removeAlertOpen,
    "onUpdate:open": _cache[0] || (_cache[0] = (value) => _unref(voucherStore).toggleOpen('remove', value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.remove_confirm.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), { class: "flex flex-col gap-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_i18n_t, {
                    keypath: "vouchers.select.remove_confirm.content",
                    tag: "span",
                    scope: "global"
                  }, {
                    body: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(voucherStore).validVoucherNumbers), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('vouchers.select.remove_confirm.description')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.yes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})